<nb-form-field>
  <input nbInput type="text" placeholder="{{placeHolderText}}" [nbAutocomplete]="autoControl"
    (input)="lookUp($event.target.value)" class="form-control form-control-sm" status="basic" fullWidth #input />

  <!-- <nb-icon icon="options-2-outline"
                     pack="eva"
                     [attr.aria-label]="lookUp"
                     (click)="openLookupDialog($event)"
                     nbSuffix>
            </nb-icon> -->
  <!-- </button> -->

  <nb-autocomplete #autoControl size="small" (selectedChange)="selectLookUp($event)">

    <nb-option *ngFor="let result of (results$ | async)" [value]="result?.id">
      <strong>{{result?.description}}</strong> &nbsp;[{{result?.id}}]
    </nb-option>

  </nb-autocomplete>
</nb-form-field>